window.HBCGoogleReviews = {
  "reviews": [
    {
      "name": "william Rees",
      "rating": 5,
      "text": "Heathrow boxing club is one of the best. I have been consistently training with them for 15 years. I am 54 and Feel like I’m 24 amazing for Fitness and Well-being, I love going there . It has helped me in so many ways, thank you, Serg 🙏",
      "date": "2026-07-24"
    },
    {
      "name": "Martyna 20",
      "rating": 5,
      "text": "Emily’s classes are some of the best!!\nEvery Monday, Wednesday, Thursday, and Friday, she thoughtfully plans each session so we target different muscle groups throughout the week. Each class starts with a 30-minute strength workout, followed by 30 minutes of boxing, creating the perfect balance of strength training and cardio. It’s an incredibly effective way to improve overall fitness, build strength, and boost endurance all while starting the day with an energizing, full-body workout.",
      "date": "2026-07-24"
    },
    {
      "name": "hap chaggar",
      "rating": 5,
      "text": "I started as a complete beginner, and every session has helped me improve my technique, skills, and fitness. Sarg is patient, knowledgeable, and create a really supportive environment that builds confidence while pushing you to improve. Highly recommend for anyone looking to learn boxing, whatever your experience level!",
      "date": "2026-07-24"
    },
    {
      "name": "Ellanor Hall",
      "rating": 5,
      "text": "Honestly can't say enough good things about this place! 5 years in and it still only gets better. Serge and Emily are such fantastic coaches - they bring so much knowledge and genuine patience to every session. You really couldn't ask for better people to teach you!",
      "date": "2026-07-23"
    },
    {
      "name": "Karmyn Thomas",
      "rating": 5,
      "text": "Joined Heathrow Boxing Club in 2024 after a year of excuses (“not into boxing”, “not fit enough”, “too late”). Best decision I’ve made.\n\nI began with Emily’s ladies classes — friendly, patient coaching and well-designed drills that tone you while making you feel like a boxer. From there I moved into the mixed sessions (pads, bags, strength). It’s predominantly men with a handful of women, yet the support is genuine. Hearing a clear “Go girl!” across the room when you’re pushing through something tough makes a real difference.\n\nSerge runs a sharp, no-nonsense programme. Clear instructions, a keen eye, and Ukrainian-style workouts that hit harder than most. You level up every class and leave wanting more. The 1-on-1 sessions are excellent if you want extra focus on technique or fitness.\n\nI’ve trained at other gyms in the UK and Australia. This is the most engaging and rewarding — you leave every session feeling properly accomplished. Clean, well-equipped, unlimited classes for a fair price, free parking on site (or street parking nearby), and toilets available.\n\nIdeal if you want structured, progressive training in a supportive environment, whether you’re starting out or already experienced. Highly recommended.",
      "date": "2026-07-23"
    },
    {
      "name": "Jas Saimbi",
      "rating": 5,
      "text": "Great boxing gym with an inspiring trainer",
      "date": "2026-07-23"
    },
    {
      "name": "Marcus O",
      "rating": 5,
      "text": "Intense, no-nonsense training that will get you in the best shape of your life. Start with a bags class and see how you get on.",
      "date": "2026-07-23"
    },
    {
      "name": "Dardan Çelaj",
      "rating": 5,
      "text": "Whether you want to be ultra fit or be the best boxer of all time this is by far the best gym in the United Kingdom and I’ve been to many gyms in my life. The main coach Serge pushes you to the absolute limit and you will never get bored of the many classes he has on offer. Absolute bargain at £130 per month for unlimited classes of which I alone do 8-10 hours worth every single week. I highly recommend this gym for anyone wanting to be the best boxer / in the best shape",
      "date": "2026-07-22"
    },
    {
      "name": "Bav K",
      "rating": 5,
      "text": "Heathrow boxing club is the best place to learn boxing and grow as an individual. All the coaches push you past your limit to make you the best version of yourself. It's a welcoming and respectful environment where all experience levels feel welcome. I highly recommend it.",
      "date": "2026-07-22"
    },
    {
      "name": "Vistar Sharma",
      "rating": 5,
      "text": "I’ve had an excellent experience at Heathrow Boxing Club. The coaches are knowledgeable, supportive, and genuinely invested in helping everyone improve, regardless of experience level. The sessions are well structured, challenging, and push you to become fitter, more disciplined, and technically better every week. The atmosphere is welcoming, respectful, and motivating, making it a great place to train consistently. Whether you’re looking to compete, learn self-defence, or simply get in the best shape of your life, I highly recommend Heathrow Boxing Club.",
      "date": "2026-07-22"
    },
    {
      "name": "Luca Szabo",
      "rating": 5,
      "text": "Guaranteed result, welcoming community, amazing coach. But be warned once you step  through the door you will be addicted to this place. For me this place is a sanctuary, no matter how mentally drained was my day after Serge session i go home lighter (mainly because no energy left to even think 🤭). Bottom line this place not just physically  helps but defo support your mental health while you are training among a supportive community regardless your skill level. Highly recommended, you won’t regret it. Thanks Serge for almost 5 years amazing classes 🥰",
      "date": "2026-07-22"
    },
    {
      "name": "Makunouchi",
      "rating": 5,
      "text": "High tehnic and good physical fitness! Smart way of teaching boxing\n. Recommend to everyone 👍",
      "date": "2026-07-22"
    },
    {
      "name": "Konstantin Kotev",
      "rating": 5,
      "text": "Best place for learning and losing weight with the best coach!",
      "date": "2026-07-22"
    },
    {
      "name": "Dumitru Bolbecov",
      "rating": 5,
      "text": "Big and clean gym, big free car park available, awesome classes with very experienced coaches !!!",
      "date": "2026-07-22"
    },
    {
      "name": "Ryan Richards",
      "rating": 5,
      "text": "I've had the privilege of training under Serge for the past 19 years, and I honestly couldn't ask for a better coach. His knowledge, dedication, and passion for boxing are second to none. He pushes everyone to be their best, whether you're a complete beginner or an experienced boxer, while always creating a positive and supportive environment.\nHeathrow Boxing Club is a fantastic place to train, with a great atmosphere and a real sense of community. I've made lifelong friends here and learned so much, not just about boxing but about discipline, respect, and hard work.\nThank you, Serge, for 19 incredible years of guidance and support. I highly recommend Heathrow Boxing Club to anyone looking for top-quality coaching and a welcoming gym.",
      "date": "2026-07-22"
    },
    {
      "name": "Ben Young",
      "rating": 5,
      "text": "The only boxing club in London!!!!! A must for all levels!",
      "date": "2026-07-22"
    },
    {
      "name": "Nams Bali",
      "rating": 5,
      "text": "My son loves his Thursday lesson.",
      "date": "2026-04-26"
    },
    {
      "name": "Mr Amoudi",
      "rating": 5,
      "text": "Hidden gem.",
      "date": "2026-04-08"
    },
    {
      "name": "Antoniya Todorova",
      "rating": 5,
      "text": "First time in my life doing this kind of sport.\nWill be my number one priority every week.\nThanks to the teacher❤️\nI am turning to the better version of me…",
      "date": "2026-02-26"
    },
    {
      "name": "Monica F",
      "rating": 5,
      "text": "I attended for the first time, and probably the last but not oweing to the club or class it’s just not the sport for me. Anyway, Emily was the teacher and she was friendly and firm, gave great exercises and drills. If weight loss, fitness, …",
      "date": "7 months ago"
    },
    {
      "name": "Gargi Talukder",
      "rating": 5,
      "text": "I’ve been coming to this boxing club for the past month and absolutely love it. After trying a few boxing clubs around West London, this one stands out as the best by far. The ladies-only classes are not just fun but they’re empowering. The …",
      "date": "a year ago"
    },
    {
      "name": "Adil Sheikh",
      "rating": 5,
      "text": "Serge is a world class coach and very patient, teaches a technique until you understand. His gym also does boxing fitness for all ages , including children, female only classes and adults who just want to keep fit. Ideal club to join if you …",
      "date": "7 months ago"
    },
    {
      "name": "Mohammad Sabil",
      "rating": 5,
      "text": "I’ve been training at this boxing gym for a couple months now, and it’s one of the most physically challenging and rewarding things I’ve do each week - even after 9+ years of regular gym workouts. The environment is incredibly welcoming for …",
      "date": "a year ago"
    },
    {
      "name": "Peter Gombar",
      "rating": 5,
      "text": "Ive started private 1-2-1 sessions with Serge about 2 months ago and its going amazing. he is a top quality boxing coach with many years of experience. excellent service, clean facility, and amazing coach. highly recommend going to this …",
      "date": "a year ago"
    },
    {
      "name": "Hannah Nall",
      "rating": 5,
      "text": "I have never tried boxing until now and I’m hooked! Emily is an excellent instructor and offers diverse and fun workout routines with motivating tunes. …",
      "date": "2 years ago"
    },
    {
      "name": "Meg Evans",
      "rating": 5,
      "text": "The Ladies classes are absolutely amazing! I started going when I was 3months postpartum, and have noticed such a significant improvement in my fitness levels. Emily is motivational and encouraging, and the classes are so friendly and welcoming. Highly recommend",
      "date": "2 years ago"
    },
    {
      "name": "joshua duckmanton",
      "rating": 5,
      "text": "Just finished a 1-2-1 session with Serge.",
      "date": "4 years ago"
    },
    {
      "name": "S O",
      "rating": 5,
      "text": "Brilliant Boxing Club it actually changed my life I should visit one day as I had to move away. If you need to get in shape or actually want to learn boxing this is the place!! 👍🏻👌🏻🙏🏻 …",
      "date": "a year ago"
    },
    {
      "name": "J h",
      "rating": 5,
      "text": "I love Heathrow boxing club ladies classes, I would go everyday if it was on.",
      "date": "2 years ago"
    },
    {
      "name": "Mandeep Sarai",
      "rating": 5,
      "text": "Excellent workouts! Really good to place to learn new boxing skills or if you want to generally want to gain fitness ! Instructor is well experienced and knows how to push trainees just that little bit extra or ease off when needed . Highly recommended",
      "date": "Edited 5 years ago"
    },
    {
      "name": "Lydia Gazzard",
      "rating": 5,
      "text": "The girls boxing class is brilliant, always good vibes and different exercises.",
      "date": "8 months ago"
    },
    {
      "name": "JMac JMac",
      "rating": 5,
      "text": "Want to get physically and mentally fit, surrounded by people who will encourage you to be your best, then this is the place. Serge is a hardcore trainer who knows when to push and hold back.",
      "date": "4 years ago"
    },
    {
      "name": "StricltyFit Personal Training",
      "rating": 5,
      "text": "Very clean, professionally run boxing place. Very intense pad work and bag work sessions! Club also offers circuit called fisical al fitness which I haven't attended but they looks fun 🥵 …",
      "date": "4 years ago"
    },
    {
      "name": "Nisham Limbu",
      "rating": 5,
      "text": "Emily has a very positive vibes, gr8 energy, very humble, easy to connect with :)always love her class  🥊 …",
      "date": "2 years ago"
    },
    {
      "name": "Vlad",
      "rating": 5,
      "text": "Great place to train for beginners and advanced, if you want to push your body to the limits that is the right place for you….!!!!!",
      "date": "a year ago"
    },
    {
      "name": "Gurdeep Verdi",
      "rating": 5,
      "text": "Great workout! Serge and Max so knowledgeable about Boxing and make sure you are training to your maximum and giving you that extra push!",
      "date": "Edited 2 years ago"
    },
    {
      "name": "Glen Mackenzie",
      "rating": 5,
      "text": "Did some training whilenworking down London, Coaches where excellent, and a very warming and great atmosphere",
      "date": "a year ago"
    },
    {
      "name": "ST Mead",
      "rating": 5,
      "text": "Amazing female coach and really supportive and beginner friendly women's only boxing classes",
      "date": "2 years ago"
    },
    {
      "name": "Yazan Radaideh",
      "rating": 5,
      "text": "Excellent work , serge the couch is very committed man and he has tons of knowledge",
      "date": "2 years ago"
    },
    {
      "name": "Transformya lifestyle",
      "rating": 5,
      "text": "Amazing place, you learn so much and more. I highly recommend this boxing club for everybody.",
      "date": "4 years ago"
    },
    {
      "name": "Manraj Sangha",
      "rating": 5,
      "text": "Great boxing club! Serg and Max an extremely solid and knowledgeable coach!",
      "date": "Edited 2 years ago"
    },
    {
      "name": "SANDING CITY SERVICE LTD",
      "rating": 5,
      "text": "Great place to blow off some steam . It feels great . I recommend it to everyone.",
      "date": "2 years ago"
    },
    {
      "name": "Valerijs Jegorovs",
      "rating": 5,
      "text": "Nice atmosphere, professional coaching. Love this place",
      "date": "2 years ago"
    },
    {
      "name": "jed moragane",
      "rating": 5,
      "text": "It very helpful to exercise your body to the max",
      "date": "2 years ago"
    },
    {
      "name": "safi",
      "rating": 5,
      "text": "Great club best boxing club in west London in my opinion",
      "date": "3 years ago"
    },
    {
      "name": "Giovanni Gianfriglia",
      "rating": 5,
      "text": "Great workout good instructor very hard.😄 …",
      "date": "9 years ago"
    },
    {
      "name": "Tim Howey",
      "rating": 5,
      "text": "Very good trainer",
      "date": "10 months ago"
    },
    {
      "name": "Yusuf Ramadhan",
      "rating": 5,
      "text": "Excellent place to workout hard and effectively 💯 …",
      "date": "3 years ago"
    },
    {
      "name": "ricky sandhar",
      "rating": 5,
      "text": "The coach has the best knowledge for boxing and fitness.",
      "date": "6 years ago"
    },
    {
      "name": "Monty",
      "rating": 5,
      "text": "Best place to get fit and healthy !👍👍👍 …",
      "date": "4 years ago"
    },
    {
      "name": "C H",
      "rating": 5,
      "text": "My kids love training here!",
      "date": "4 years ago"
    },
    {
      "name": "Mariusz Kania",
      "rating": 5,
      "text": "Good place for heavy workout!",
      "date": "7 years ago"
    },
    {
      "name": "Samvels Koledzjans",
      "rating": 5,
      "text": "Unbelievable coaches , children and training.",
      "date": "3 years ago"
    },
    {
      "name": "Fenn Berens",
      "rating": 5,
      "text": "Very good boxing lessons",
      "date": "7 years ago"
    },
    {
      "name": "Reena anand",
      "rating": 5,
      "text": "100% recommend this place",
      "date": "3 years ago"
    },
    {
      "name": "Nano AM",
      "rating": 5,
      "text": "No pain, no gain",
      "date": "7 years ago"
    },
    {
      "name": "Suited Ralph",
      "rating": 5,
      "text": "great place.",
      "date": "3 years ago"
    },
    {
      "name": "Samanta Baze",
      "rating": 5,
      "text": "Best place to get fit",
      "date": "9 years ago"
    },
    {
      "name": "Zubair Hussain",
      "rating": 5,
      "text": "Very gods class",
      "date": "9 years ago"
    }
  ]
};
